const PATH = {
  ClientsPage: '/clients-page',
  clientControlPage: '/client-control-page',
  establishmentPage: '/establishment-page/',
  statsPage: '/stats-page/',
  menuPage: '/menu-page/',
  collectOrdersPage: '/collectOrders-page',
  authPage: '/auth-page/',
  mainPage: '/',
  siteManagementPage: '/site-management-page/',
  registrationPage: '/registration-page/',
  passwordRecoveryPage: '/password-recovery-page/',
  platformCardPage: '/platform-card-page/',
  establishmentCardPage: '/establishment-card-page/',
  editEstablishmentCardPage: '/edit-establishment-card-page/',
  reservationPlatformPage: '/reservation-platform-page/',
  editPlatformCardPage: '/edit-platform-card-page/',
  administratorsManagementPage: '/administrators-management-page/',
  adminCardPage: '/admin-card-page/',
  companyManagementPage: '/company-management-page/',
  companyCardPage: '/company-card-page/',
  editCompanyCardPage: '/edit-company-card-page/',
  companyManagementStaffPage: '/company-management-staff-page/',
  companyStaffCardPage: '/company-staff-card-page/',
  editStaffCardPage: '/edit-staff-card-page/',
  companyManagementPlatformsPage: '/company-management-platforms-page/',
  claimManagementPage: '/claim-management-page/',
  strPage: '/str-page/',
  claimManagementCurrentPlatformPage: '/claim-management-current-platform-page/',
  claimCardPage: '/claim-card-page/',
  editClaimCardPage: '/edit-claim-card-page/',
  registerConfirmation: '/register-confirmation',
  passwordRecoveryConfirmation: '/password-recovery-confirmation',
  requestForRegistration: '/request-for-registration',
  requestForRegistrationCardPage: '/request-for-registration-card-page/',
  blockedPage: '/blocked-page',
  passwordRecoveryCodePage: '/password-recovery-code-page/',
  passwordRecoveryResetPasswordPage: '/password-recovery-reset-password-page/',
  profilePage: '/profile-page/',
  companyPage: '/company-page/',
  editCompanyPage: '/edit-company-page/',
  createPlatformPage: '/create-platform-page/',
  createEstablishmentPage: '/create-establishment-page',
  companyManagementStaffPageAdmin: '/company-management-staff-page-admin/',
  companyStaffCardPageAdmin: '/company-staff-card-page-admin/',
  error404: '/error404',
  claimsPage: '/claims-page',
  bookingPage: '/booking-page',
}

export default PATH
